import React from 'react';

const CTA = () => {
  return (
    <section id="cta" className="cta-section">
      <div className="container">
        <div className="cta-box">
          <h2 className="cta-title">
            Ready To Scale<br/>
            <span className="text-gradient-teal-gold">Your Brand?</span>
          </h2>
          <p className="cta-desc">Let's discuss how we can help you achieve your business goals.</p>
          <div className="cta-buttons">
            <button className="btn-primary" onClick={() => window.open('https://wa.me/917227095393', '_blank')}>Book A Discovery Call</button>
            <button className="btn-secondary" onClick={() => window.open('https://wa.me/917227095393', '_blank')}>Get a Quote</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
